module.exports = __webpack_public_path__ + "common/icon-whatsapp-049ffbc2e9001ca56a98247d0be1b4bf.svg";